import { render, staticRenderFns } from "./ShiftMembersDialog.vue?vue&type=template&id=12e3866c&scoped=true"
import script from "./ShiftMembersDialog.vue?vue&type=script&lang=js"
export * from "./ShiftMembersDialog.vue?vue&type=script&lang=js"
import style0 from "./ShiftMembersDialog.vue?vue&type=style&index=0&id=12e3866c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e3866c",
  null
  
)

export default component.exports